import cloneDeep from "lodash/cloneDeep";
import reject from "lodash/reject";
import initializeShowNamesNodeStyle from "../styling/initializeShowNamesNodeStyle";
export default (graphComponentRef, renderingManager, showNamesRef, changeNodeNameTimersRef) => (documentObjectId, attributeId, fieldName, value) => {
    var _a;
    if (!graphComponentRef.current || !renderingManager || (!attributeId && !fieldName))
        return undefined;
    const node = graphComponentRef.current.graph.nodes.find(n => n.tag && n.tag.Id === documentObjectId);
    if (!node || !node.tag)
        return undefined;
    const nodeTag = cloneDeep(node.tag);
    if (attributeId) {
        if (!nodeTag.Attributes)
            return nodeTag;
        if (!fieldName) {
            nodeTag.Attributes = reject(nodeTag.Attributes, ["Id", attributeId]);
            node.tag = nodeTag;
            return nodeTag;
        }
        const attributeIndex = (_a = nodeTag.Attributes) === null || _a === void 0 ? void 0 : _a.findIndex(a => a.Id === attributeId);
        if (attributeIndex === -1)
            return nodeTag;
        nodeTag.Attributes[attributeIndex][fieldName] = value;
        node.tag = nodeTag;
        return nodeTag;
    }
    if (!fieldName)
        return nodeTag;
    nodeTag[fieldName] = value;
    node.tag = nodeTag;
    if (fieldName === "Name") {
        changeNodeNameTimersRef.current[nodeTag.Id] &&
            clearTimeout(changeNodeNameTimersRef.current[nodeTag.Id]);
        changeNodeNameTimersRef.current[nodeTag.Id] = setTimeout(async () => {
            if (!graphComponentRef.current || !graphComponentRef.current.graph.contains(node))
                return;
            await initializeShowNamesNodeStyle(nodeTag);
            if (showNamesRef.current)
                renderingManager.setWebGL2NodeStyle(node, graphComponentRef.current.selection.selectedNodes.includes(node), false, true);
        }, showNamesRef.current ? 500 : 1000);
    }
    return nodeTag;
};
